// API Configuration
// In development, use relative API path and rely on package.json proxy.
// In production, use explicit origin if needed.
const API_URL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_API_URL || "https://historio.hr"
    : process.env.REACT_APP_API_URL || "";

export default API_URL;
